import { MDBBtn, MDBIcon } from "mdbreact"
import React from "react"
import { Col, Input, Label, Modal, ModalBody, ModalFooter, Row } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import _valid from "../../validations"

export default class HistorialFormulario extends React.Component {

    constructor(props) {
        super(props);
        this.apiRest = new ApiRest(props);
        const actualizarSolicitud = _valid(this.props.solicitud);
        this.state = {
            solicitud: actualizarSolicitud && this.props.solicitud,
            estado: actualizarSolicitud && this.props.estado,
            registro: { comentario: "" }
        };
        this.regresar = this.regresar.bind(this);
        this.almacenarRegistro = this.almacenarRegistro.bind(this);
    }

    almacenarRegistro = () => {
        const { comentario } = this.state.registro;
        if (_valid(comentario)) {
            const { estado, solicitud } = this.state;
            let datos = { comentario };
            if (estado !== undefined) {
                datos["estado"] = parseInt(estado);
            }
            if (solicitud) {
                datos["solicitud"] = solicitud;
            }
            this.apiRest.post('/historial', datos).then(resultado => {
                return this.props.seGuardoEnHistorial(resultado.exitoso);
            });
        } else {
            toastr.error("Escribe un comentario.");
        }
    }

    regresar() {
        return this.props.seGuardoEnHistorial(false);
    }

    render() {
        return (
            <Modal isOpen={this.props.estadoModal}>
                <ModalBody>
                    <Row>
                        <Label htmlFor="comentario" className="form-label">
                            Comentario (Para el historial)
                        </Label>
                        <Input
                            value={this.state.registro.comentario}
                            onChange={({ target: { value } }) => this.setState(ant => ({ ...ant, registro: { ...ant.registro, comentario: value } }))}
                            name="comentario"
                            type="textarea"
                            className="form-control"
                            placeholder="Escribe un comentario"
                        />
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Col lg={12} className="text-end">
                        <MDBBtn className="waves-effect" color="success" onClick={this.almacenarRegistro}>
                            <MDBIcon icon="fas fa-user-check" /> {' '}
                            Listo
                        </MDBBtn>
                        {' '}
                        <MDBBtn className="waves-effect" color="warning" onClick={this.regresar}>
                            <MDBIcon icon="fas fa-arrow-left" />{' '}
                            Cancelar
                        </MDBBtn>
                    </Col>
                </ModalFooter>
            </Modal>
        );
    }
}